import React from 'react'
import "./BtnPromocionesStyle.css"

let botonOfertas = "";
export const BtnPromociones = () => {
  return (
    <div>{botonOfertas}</div>
  )
}